export default {
  WhtCode: "",
  Description: "",
  WhtRate: 0,
  UserModified: localStorage.getItem("UserName"),
};
